import React from "react";
import { IconButton } from "../../components";
import { ClientReportManagementPageSubHeader, FiltersAppliedWarningMessage, ThemedIcon } from "../../components/utilities";
import CreateStandardParagraphModal from "../../features/createstandardparagraphmodal";
import { StandardParagraphFiltersModal } from "../../features/standardparagraphfilters";
import { StandardParagraphFilterProvider, useStandardParagraphFilterContext } from "../../features/standardparagraphfilters/hooks/StandardParagraphFilterContext";
import withProviders from "../../hooks/withProviders";
import StandardParagraphManagementTable from "../../features/standardparagraphmanagementtable";

const StandardParagraphManagementPage = () => {
    const [showCreate, setShowCreate] = React.useState(false);
    const { setShowFilterModal, isFiltersApplied, resetFilter } = useStandardParagraphFilterContext();

    return <>
        <CreateStandardParagraphModal
            show={showCreate}
            onHide={() => setShowCreate(false)}
        />
        <StandardParagraphFiltersModal />
        <ClientReportManagementPageSubHeader>
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    {isFiltersApplied && (
                        <React.Fragment>
                            <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                            <FiltersAppliedWarningMessage className="ms-2 text-muted">
                                Warning - Filters are currently being applied to your results.
                                <br />
                                <button className="anchor" onClick={resetFilter}>Click here</button> to clear your filters.
                            </FiltersAppliedWarningMessage>
                        </React.Fragment>
                    )}
                </div>
                <div className="d-flex flex-fill justify-content-end align-items-center gap-2">
                    <IconButton icon={['fas', 'filter']} onClick={() => setShowFilterModal(true)}>
                        Filter Paragraphs
                    </IconButton>
                    <IconButton icon={['fas', 'plus']} variant={'success'} onClick={() => setShowCreate(true)}>
                        Create new Paragraph
                    </IconButton>
                </div>
            </div>
        </ClientReportManagementPageSubHeader>
        <section className="px-4 my-3 h-100">
            <StandardParagraphManagementTable />
        </section>
    </>
}

export default withProviders(StandardParagraphFilterProvider)(StandardParagraphManagementPage);